import CommonApi from '@/api/common'
import locator from '@/service-locator'

const state = {
  global: {
    chatbotServiceProvider: '',
  },
  fetchedGlobalConfig: false,
}

const getters = {
  chatbotServiceProvider: (state) => {
    return (
      state.global.chatbotServiceProvider ||
      locator.config.defaultChatbotService
    )
  },
}

const mutations = {
  SET_GLOBAL_CONFIGURATION: (state, config) => {
    const newConfig = config || {}

    state.global = {
      ...state.global,
      ...newConfig,
    }
  },
  SET_FETCHED_GLOBAL_CONFIGURATION: (state, value) => {
    state.fetchedGlobalConfig = value
  },
}

const actions = {
  async fetchGlobalConfiguration({ commit, state }) {
    try {
      if (state.fetchedGlobalConfig) {
        return state.global
      }

      const { data: config } = await CommonApi.fetchGlobalConfiguration()

      commit('SET_GLOBAL_CONFIGURATION', config)
      commit('SET_FETCHED_GLOBAL_CONFIGURATION', true)

      return config
    } catch (_) {
      console.warn('Tamara: Cannot fetch global config from BE')

      return {
        chatbotServiceProvider: locator.config.defaultChatbotService,
      }
    }
  },
}

export default { namespaced: true, state, getters, mutations, actions }
